import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { Button } from '..';
import { staticConfig } from '../../config/static';

import styles from './noaccess.module.scss';

export default function NoAccess() {
    return (
        <div className="d-flex h-100">
            <div className="d-flex flex-column flex-fill overflow-auto">
                <section
                    className={[
                        'd-flex flex-fill align-items-center justify-content-center w-100',
                        styles.systemError,
                    ].join(' ')}
                >
                    <section className="d-flex flex-column">
                        <FormattedHTMLMessage tagName="div" id="NO_ACCESS_LOGON" />
                        <section className="d-flex ml-auto p-2 flex-column flex-sm-row justify-content-sm-between">
                            <Button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.location.replace(staticConfig.appBaseUrl);
                                }}
                            >
                                <FormattedMessage id="BACK" />
                            </Button>
                        </section>
                    </section>
                </section>
            </div>
        </div>
    );
}
